import React from "react";
import styled from "styled-components";

export default function Error404Page() {
  return (
    <ContainerStyled>
      <h1>404 - Страница не найдена</h1>
      <p>К сожалению, запрашиваемая Вами страница не найдена.</p>
    </ContainerStyled>
  );
}
const ContainerStyled = styled.div`
  margin: 20px;
`;
